import { useMemo, useState } from 'react'
import { useDomain } from 'context'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import Button from '@app.components/Button'
import ChatAppModal from '@app.components/modals/ChatAppModal/ChatAppModal'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { mobileBreakPoint } from 'app.styled/media'
import Bell from 'svgIcons/notification/Bell'
import EmptyNotificationDescription from './EmptyNotificationDescription'

const Tabs = {
  ACTIVITY: 'activity',
  CHANNEL: 'channel',
  COMMUNITY: 'community',
  CHAT: 'chat',
}

const EmptyNotification = () => {
  const router = useRouter()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()
  const { protocol, xen } = useDomain()
  const selectedTab = useMemo(() => {
    return String(router.query.tab)
  }, [])
  const [isAppModalOpen, setIsAppModalOpen] = useState(false)

  const handleClickButton = () => {
    if (selectedTab === Tabs.ACTIVITY) {
      router.push('/list/recruit')
    }
    if (selectedTab === Tabs.CHANNEL) {
      router.push('/channel')
    }
    if (selectedTab === Tabs.COMMUNITY) {
      router.push(`${protocol}://${xen}/best`)
    }
    if (selectedTab === Tabs.CHAT) {
      if (isMobile) {
        isWebview ? router.push('/chat') : setIsAppModalOpen(true)
      } else {
        router.replace({
          query: { ...router.query, chatOpenType: 'default' },
        })
      }
    }
  }
  return (
    <StyledWrapper>
      <div className="ico">
        <Bell />
      </div>
      <div className="empty-noti-desc">
        새로운 <span>알림</span>이 없습니다.
      </div>
      {Object.values(Tabs).includes(selectedTab) && (
        <>
          <EmptyNotificationDescription selectedTab={selectedTab} Tabs={Tabs} />
          <Button
            className="empty-noti-btn"
            color="lightGrey"
            onClick={handleClickButton}
          >
            {selectedTab === Tabs.ACTIVITY && '채용공고 보기'}
            {selectedTab === Tabs.CHANNEL && '채널 보기'}
            {selectedTab === Tabs.COMMUNITY && '베스트 인기글 보기'}
            {selectedTab === Tabs.CHAT && '채팅방 바로가기'}
          </Button>
        </>
      )}
      <ChatAppModal
        open={isAppModalOpen}
        onClose={() => setIsAppModalOpen(false)}
      />
    </StyledWrapper>
  )
}

export default EmptyNotification

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 129px 0;
  .ico {
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #efefef;
    margin-bottom: 14px;
  }
  .empty-noti-desc {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -0.64px;
    color: #999;
  }
  .empty-noti-btn {
    color: #333;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: -0.48px;
    padding: 10px 20px 11px;
  }

  ${mobileBreakPoint} {
    padding: 92px 0 101px;
    .ico {
      width: auto;
      height: auto;
      background-color: #fff;
      svg {
        width: 78px;
        height: 78px;
      }
    }
    .empty-noti-desc {
      color: #333;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: -0.8px;
      span {
        color: #01a0ff;
      }
    }
  }
`
